import "./CreditPayEfficiencyFilters.scss";
import { useTranslation } from "react-i18next";
import {useState} from 'react';
import AppSlider from "../AppSlider/AppSlider";
import RangedRadioFilter from "../RangedRadioFilter/RangedRadioFilter";
import { useEffect } from "react";
import { usePairingPackage } from "../../providers/PairingPackage";

// interface cpeFilterInterface {
//   credit: string[] | null;
//   hoursPerDay: string[] | null;
//   expenses: string[] | null;
//   canCostDaily: string[] | null;
//   efficiency: string[] | null;
//   dayCredit: string[] | null;
//   nightCredit: string[] | null;
//   dhCredit: string;
//   oseas: string;
// }


//  need to change
interface selectedDetailsInterface {
  credit: string;
  hoursPerDay: string;
  expenses: string;
  canCostDaily: string;
  efficiency: string;
  dayCredit: string;
  nightCredit: string;
  dhCredit: string;
  oseas: string
}

// interface propInterface {
//   cpeFilterDetails: cpeFilterInterface;
//   onSelect: any;
//   selectedDetails: selectedDetailsInterface;
// }

/**
 * This is the filter component 
 * @param param0 The props passed into the component
 * @returns The Credit, Pay, Efficiency Filter Component
 */
export default function CreditPayEfficiencyFilters({
  displayFiltersClicked,
  setSelectedFilters,
  selectedFilters
}) {
  const { t } = useTranslation();
  const pairingContext = usePairingPackage();

  // object containing list of labels
  const labelNames: selectedDetailsInterface = {
    credit: t("filters.creditPayEfficiency.credit"),
    hoursPerDay: t("filters.creditPayEfficiency.hoursPerDay"),
    expenses: t("filters.creditPayEfficiency.expenses"),
    canCostDaily: t("filters.creditPayEfficiency.caPerDay"),
    efficiency: t("filters.creditPayEfficiency.efficiency"),
    dayCredit: t("filters.creditPayEfficiency.dayCredit"),
    nightCredit: t("filters.creditPayEfficiency.nightCredit"), 
    dhCredit: t("filters.creditPayEfficiency.dhCredit"),
    oseas: t("filters.creditPayEfficiency.oseas")
  };


  const [cpeInfo, setCpeInfo] = useState<any>({
    expenses: selectedFilters.selectedCpeFilter.expenses,
    credit: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.credit.selected},
    hoursPerDay: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.hoursPerDay.selected},
    efficiency: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.efficiency.selected},
    dayCredit: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.dayCredit.selected},
    nightCredit: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.nightCredit.selected},
    dhCredit: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.dhCredit.selected},
    oseas: {range:[0 ,0], selection: selectedFilters.selectedCpeFilter.oseas.selected},
  });

  const sliderDefaultState = {
    credit: cpeInfo.credit,
    hoursPerDay: cpeInfo.hoursPerDay,
    dayCredit: cpeInfo.dayCredit,
    nightCredit: cpeInfo.nightCredit,
    dhCredit: cpeInfo.dhCredit,
    oseas: cpeInfo.oseas,
    efficiency: cpeInfo.efficiency
  };
  // const textDefaultState = {
  //   // canCostDaily: cpeInfo.canCostDaily,
  //   expenses: cpeInfo.expenses
  // };
  const stateMapper = new Map();
    stateMapper.set('credit', 'credit');
    stateMapper.set('hoursPerDay', 'hoursPerDay');
    stateMapper.set('efficiency', 'eff');
    stateMapper.set('dayCredit', 'daycredit');
    stateMapper.set('nightCredit', 'nightcredit');
    stateMapper.set('dhCredit', 'dhCredit');
    stateMapper.set('oseas', 'overseasCredit');
    // stateMapper.set('canCostDaily', 'cadollarperday');
    stateMapper.set('expenses', 'expenses');

  useEffect(() => {
    if (!pairingContext.pairingPackageData.pairingList.length) {
      return;
    }

    let sortAsend = (a,b) => a > b ? 1 : b > a ? -1 : 0;
    let builtState = Object.keys(sliderDefaultState).map(key => ({[key]: sliderDefaultState[key].range = getMinMax(pairingContext.pairingPackageData.pairingList.map(f => f[stateMapper.get(key)]), sortAsend)}));
    let arrayToObject = builtState.reduce((a,n) => {
      let tempKey = Object.keys(n)[0];
      let defaultObj = {range: n[tempKey], selection: n[tempKey]};
    return {...a, [tempKey]: defaultObj};
  },{} as any);

    setCpeInfo({
      ...cpeInfo,
      ...arrayToObject
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairingContext.pairingPackageData]);

  // If filter value has been updated, display saved filter values on slider else display default min/max range when selected = [-1,-1], understand that [0,0] is a valid range
  useEffect(() => { 
    setCpeInfo({
      expenses: selectedFilters.selectedCpeFilter.expenses,
      credit: {...cpeInfo.credit, selection: selectedFilters.selectedCpeFilter.credit.selected[0]===-1 &&selectedFilters.selectedCpeFilter.credit.selected[1]===-1?cpeInfo.credit.range :selectedFilters.selectedCpeFilter.credit.selected },
      hoursPerDay: {...cpeInfo.hoursPerDay, selection: selectedFilters.selectedCpeFilter.hoursPerDay.selected[0]===-1 &&selectedFilters.selectedCpeFilter.hoursPerDay.selected[1]===-1?cpeInfo.hoursPerDay.range :selectedFilters.selectedCpeFilter.hoursPerDay.selected},
      efficiency: {...cpeInfo.efficiency, selection: selectedFilters.selectedCpeFilter.efficiency.selected[0]===-1 &&selectedFilters.selectedCpeFilter.efficiency.selected[1]===-1?cpeInfo.efficiency.range :selectedFilters.selectedCpeFilter.efficiency.selected},
      dayCredit: {...cpeInfo.dayCredit, selection: selectedFilters.selectedCpeFilter.dayCredit.selected[0]===-1 &&selectedFilters.selectedCpeFilter.dayCredit.selected[1]===-1?cpeInfo.dayCredit.range :selectedFilters.selectedCpeFilter.dayCredit.selected},
      nightCredit: {...cpeInfo.nightCredit, selection: selectedFilters.selectedCpeFilter.nightCredit.selected[0]===-1 &&selectedFilters.selectedCpeFilter.nightCredit.selected[1]===-1?cpeInfo.nightCredit.range :selectedFilters.selectedCpeFilter.nightCredit.selected},
      dhCredit: {...cpeInfo.dhCredit, selection: selectedFilters.selectedCpeFilter.dhCredit.selected[0]===-1 &&selectedFilters.selectedCpeFilter.dhCredit.selected[1]===-1?cpeInfo.dhCredit.range :selectedFilters.selectedCpeFilter.dhCredit.selected},
      oseas: {...cpeInfo.oseas, selection: selectedFilters.selectedCpeFilter.oseas.selected[0]===-1 &&selectedFilters.selectedCpeFilter.oseas.selected[1]===-1?cpeInfo.oseas.range :selectedFilters.selectedCpeFilter.oseas.selected},
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const getMinMax = (arr, customFunction: any = undefined) => {
    let min = customFunction ? arr.slice().sort(customFunction) : arr.slice().sort();
    if (!min[0]) {
      min[0] = 0;
    }
    if (!min[arr.length - 1]) {
      min[arr.length - 1] = 0;
    }
    return [min[0], min[arr.length - 1]];
  };

  useEffect(() => {
    if (!displayFiltersClicked) {
      return;
    }

    // set the selected filter in pairing package scope
    setSelectedFilters((prevState) => {
      return {
        ...prevState,
        selectedCpeFilter: {
          expenses: cpeInfo.expenses,
          credit: {selected: cpeInfo.credit.selection || [-1, -1]},
          hoursPerDay: {selected: cpeInfo.hoursPerDay.selection || [-1, -1]},
          efficiency: {selected: cpeInfo.efficiency.selection || [-1, -1]},
          dayCredit: {selected: cpeInfo.dayCredit.selection || [-1, -1]},
          nightCredit: {selected: cpeInfo.nightCredit.selection || [-1, -1]},
          dhCredit: {selected: cpeInfo.dhCredit.selection || [-1, -1]},
          oseas: {selected: cpeInfo.oseas.selection || [-1,-1]},
        }
      }
    });
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayFiltersClicked]);

  // on change event for the sliders in the AppSlider component
  const onChangeSlider = (event: any, newValue: number| number[]) => {
    setCpeInfo({
      ...cpeInfo,
      [event.target.name]: {...cpeInfo[event.target.name], selection: (newValue as number[])}
    });
  }

  // On change event for the radio button in the RangedRadioFilter Component
  const onChangeRadio = (e) => {
    // temporary
    const temp = {filter: e.target.value, max: null, min: null, eq: null}
    setCpeInfo(prev => {
      return { ...prev, [e.target.name]: temp }
    })
  }

  // on handle event for the text input field in the RangedRadioButton 
  const numberChange = (event) => {
    // extract the details from the parameter object
    const filterName = event.target.name;
    const newValue = event.target.value;
    let tempObj = {};
    Object.keys(newValue).filter(f => f !== 'filter').forEach((k) => {
      tempObj[k] = parseFloat(newValue[k])>= 0 ? parseFloat(newValue[k]) : null;
    });
    // update cpeInfo
    setCpeInfo(prev => {
      return {
        ...prev,
        [filterName]: {filter: newValue.filter, ...tempObj}
      };
    });
  }


  return (
    <div className="cpe-filter-container">
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        {/* Credit */}
        <AppSlider label={labelNames.credit} desc={t('filters.creditPayEfficiency.desc.credit')} min={cpeInfo.credit.range[0]} max={cpeInfo.credit.range[1]} value={cpeInfo.credit.selection} onChange={onChangeSlider} name='credit' />


        {/* Hrs per Day */}
        <AppSlider label={labelNames.hoursPerDay} desc={t('filters.creditPayEfficiency.desc.hoursDay')} min={cpeInfo.hoursPerDay.range[0]} max={cpeInfo.hoursPerDay.range[1]} value={cpeInfo.hoursPerDay.selection} onChange={onChangeSlider} name='hoursPerDay' />

        {/* Expenses */}
        <RangedRadioFilter label={labelNames.expenses} onChange={onChangeRadio} value={cpeInfo.expenses} name={'expenses'} textChange={numberChange} />

        {/* CA$ per Day */}
        {/* <RangedRadioFilter label={labelNames.canCostDaily} onChange={onChangeRadio} value={cpeInfo.canCostDaily} name={'canCostDaily'} textChange={textChange} /> */}


        {/* Efficiency */}
        <AppSlider label={labelNames.efficiency} min={cpeInfo.efficiency.range[0]} max={cpeInfo.efficiency.range[1]} value={cpeInfo.efficiency.selection} onChange={onChangeSlider} name='efficiency' type="percentage" />

        {/* Day Credit */}
        <AppSlider label={labelNames.dayCredit} desc={t('filters.creditPayEfficiency.desc.dayCredit')} min={cpeInfo.dayCredit.range[0]} max={cpeInfo.dayCredit.range[1]} value={cpeInfo.dayCredit.selection} onChange={onChangeSlider} name='dayCredit' />


        {/* Night Credit */}
        <AppSlider label={labelNames.nightCredit} desc={t('filters.creditPayEfficiency.desc.nightCredit')} min={cpeInfo.nightCredit.range[0]} max={cpeInfo.nightCredit.range[1]} value={cpeInfo.nightCredit.selection} onChange={onChangeSlider} name='nightCredit' />


        {/* DH Credit */}
        <AppSlider label={labelNames.dhCredit} desc={t('filters.creditPayEfficiency.desc.dhCredit')} min={cpeInfo.dhCredit.range[0]} max={cpeInfo.dhCredit.range[1]} value={cpeInfo.dhCredit.selection} onChange={onChangeSlider} name='dhCredit' />


        {/* Oseas Credit */}
        <AppSlider label={labelNames.oseas} desc={t('filters.creditPayEfficiency.desc.oSeasCredit')} min={cpeInfo.oseas.range[0]} max={cpeInfo.oseas.range[1]} value={cpeInfo.oseas.selection} onChange={onChangeSlider} name='oseas' /> 

      </form>
    </div>
  );
}
